import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { map, Observable, Subscription } from "rxjs";
import { AppState } from "src/app/@store/reducers";
import { StsSelectors } from "src/app/@store/selectors/sts.selectors";
import { ErrorCode } from 'src/app/appsettings';
import { WhiteLabelNames } from 'src/app/plasma-ui-common/enums/white-label.enum';
import { EmailPattern as emailPattern } from "src/app/plasma-ui-common/utils/regex.util";
import { ApiService } from "src/app/services/api/api.service";
import { ConfigService } from "src/app/services/config/config.service";
import { WindowRefService } from "src/app/services/window-ref.service";

@Component({
    selector: 'app-send-forgot-password',
    templateUrl: './send-forgot-password.component.html',
    styleUrls: ['./send-forgot-password.component.scss'],
    standalone: false
})
export class SendForgotPasswordComponent implements OnInit, OnDestroy {
  public isUkShfyInstance$: Observable<boolean> = this.store.select(StsSelectors.isUkShfyInstance);
  readonly endpoint = '/account/sendforgotpassword';
  readonly emailPattern = new RegExp(emailPattern);
  returnUrl = '';
  form: UntypedFormGroup;
  sub: Subscription;
  message = '';
  loading = false;
  submitted = false;

  isUserDeactivated: boolean = false;
  deactivatedMessage: string = null;

  isYellowIndigoUI$ = this.store
    .select(StsSelectors.getWhiteLabelName)
    .pipe(map(name => name === WhiteLabelNames.ITALY || name === WhiteLabelNames.GLOBAL));
  isUkDfp$ = this.store.select(StsSelectors.isUkDfpInstance);
  isGlobal$ = this.store.select(StsSelectors.isGlobalTenant);

  constructor(
    private api: ApiService,
    private activeRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    private config: ConfigService,
    private windowRef: WindowRefService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
    });
    this.returnUrl = btoa(encodeURIComponent(this.activeRoute.snapshot.queryParams.returnUrl));
  }

  get email() {
    return this.form.get('email');
  }

  ngOnInit() {
    this.sub = this.form.get('email').valueChanges.subscribe(n => (this.submitted = false));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit() {
    this.isUserDeactivated = null;
    this.message = null;
    this.loading = true;

    const email = encodeURIComponent(this.email.value);
    this.api
      .post(`${this.endpoint}?returnUrl=${encodeURIComponent(this.returnUrl)}&email=${email}`)
      .subscribe(
        () => { this.message = `sendSuccess`; },
        e => {
          const { error } = e;
          if (error) {
            const { errorCode, errorMessage } = error;
            this.isUserDeactivated = errorCode == ErrorCode.USER_DEACTIVATED;
            this.deactivatedMessage = errorMessage;
          }
        },
      ).add(() => {
        this.loading = false;
        this.submitted = true;
      });
  }

  onCancel() {
    this.windowRef.nativeWindow.location.href = `${this.config.baseAuthUrl}/Account/Login${window.location.search}`;
  }

  onClear(controlName: string) {
    this.form.get(controlName).reset();
  }
}
